import React from "react";
import PropertyCard from "./PropertyCard";
import type { Property } from "../PropiedadesPageNew";

interface PropertyGridProps {
    propiedades: Property[];
    loading: boolean;
    activeView: string;
    selectedProp: Property | null;
    isDrawerOpen: boolean;
    onPropClick: (prop: Property) => void;
}

const PropertyGrid: React.FC<PropertyGridProps> = ({
    propiedades,
    loading,
    activeView,
    selectedProp,
    isDrawerOpen,
    onPropClick
}) => {
    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center py-20">
                <svg className="animate-spin h-8 w-8 text-[#4f6df5]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" strokeDasharray="30" strokeLinecap="round" />
                </svg>
                <p className="mt-4 text-sm text-gray-500">Obteniendo propiedades...</p>
            </div>
        );
    }

    if (propiedades.length === 0) {
        return (
            <div className="text-center py-20 border-2 border-dashed border-gray-200 bg-gray-50/50 rounded-xl text-gray-500 text-sm">
                No se encontraron propiedades para este filtro.
            </div>
        );
    }

    return (
        <div className={`grid gap-4 ${activeView === 'grid' ? 'grid-cols-[repeat(auto-fill,minmax(260px,1fr))]' : 'grid-cols-1'}`}>
            {propiedades.map((prop) => (
                <PropertyCard
                    key={prop.id}
                    prop={prop}
                    activeView={activeView}
                    isSelected={selectedProp?.id === prop.id && isDrawerOpen}
                    onClick={onPropClick}
                />
            ))}
        </div>
    );
};

export default PropertyGrid;